import React from "react";
import PtoMonthCalendar from "./pto-month-calendar";
import PtoWeekCalendar from "./pto-week-calendar";
import { VIEW_MODE } from "./_common";


export default class PtoCalendar extends React.Component {

    constructor(props) {
        super(props);

        this.calendar = React.createRef(null);

    }

    reload() {
        if (this.calendar.current) this.calendar.current.reload();
    }

    render() {
        const { viewSettings, ...rest } = this.props;
        const mode = viewSettings.viewMode;
        
        return (
            <div className="pto-calendar">
                {
                    mode === VIEW_MODE.WEEK ?
                        <PtoWeekCalendar ref={this.calendar} {...this.props} /> :
                        <PtoMonthCalendar ref={this.calendar} {...this.props} />
                }
            </div>
        );
    }
}